export const shortLivedConfig = {
  Auth: {
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_POOLS_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_POOLS_WEB_CLIENT_ID_SECONDARY,
  },
};

export const longLivedConfig = {
  Auth: {
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_POOLS_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_POOLS_WEB_CLIENT_ID,
  },
};
